import { useState } from "react";

// redux
import { useStore, useSelector } from "react-redux";
import { success, error as toastError } from "hyc-store/reducers/toast";

// reducers
import { selectCountry } from 'hyc-store/reducers/countries/countriesReducer';

// components
import { Button } from "shared/components/bulma/button";

import * as helper from "./helper";

const ChargeButton = ({ box }) => {
    const [newBox, setNewBox] = useState(box);
    const country = useSelector(selectCountry);

    const store = useStore();

    const handleClick = async () => {
        if (!window.confirm(`Are you sure you want to create a late box subscription on Stripe for this customer?`)) {
            return;
        }

        try {
            await helper.chargeLateBox(newBox, country);
            store.dispatch(success('Success! The customer has been charged on Stripe!'));
            setNewBox({ ...newBox, is_charged: true });
        } catch (error) {
            store.dispatch(toastError(error.message));
        };
    };

    const buttonClasses = [
        'button is-link',
        newBox.is_charged ? '' : 'is-outlined'
    ].join(' ');

    const value = newBox.is_charged ? "Charged" : "Charge customer";

    return (
        <Button name="charge" className={buttonClasses}
            onClick={handleClick}>
            {value}
        </Button>
    )
}

export { ChargeButton };
